import { Icon } from "@mui/material";
import KeyboardArrowDownOutlinedIcon from "@mui/icons-material/KeyboardArrowDownOutlined";
import { Link } from "react-router-dom";

const Tips: React.FC = () => {
  return (
    <div>
      <section>
        <div className="flex mx-10 justify-center w-auto h-96 bg-cover rounded-3xl bg-blend-darken bg-center bg-[url('https://www.searchenginejournal.com/wp-content/uploads/2022/03/women-in-seo-6220de185a646-sej-760x400.webp')]">
          <span className="flex bg-black bg-opacity-50 w-full justify-center font-semibold text-5xl py-44 brightness-100 text-white rounded-3xl">
            Dicas
          </span>
        </div>
      </section>
      {/* video-card */}
      <section>
        <div className="static flex text-justify items-center h-96 bg-primary-50 dark:bg-gray-600 rounded-3xl mx-52 my-20">
          <span className="w-2/3 px-10">
          Aqui você encontra as melhores dicas de produtos e serviços em sua cidade e também ao redor do mundo. Dicas usadas e aprovadas por vocês!!! Então podem confiar! Deixem seus comentários e seu like, é super importante o feed back de vocês para que continuemos contratando esses profissionais!!! O Radar preza muito pela confiabilidade e segurança nas informações. Mas não nos responsabilizamos pelas dicas dadas em nossa comunidade.
          </span>

          <iframe
            className="absolute right-32 shadow-2xl rounded-3xl w-3/12"
            width="560"
            height="315"
            src="https://www.youtube.com/embed/W_0pstoCUmM?si=BhgWpDavTRSTxNWo"
            title="YouTube video player"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          ></iframe>
        </div>
      </section>
      <section>
        <div className="flex-row mx-52 justify-between">
          <div className="flex items-center justify-between">
            <div className="flex items-center mb-[-18px]">
              <span>
                <Link to={'/'}>Home</Link> &gt; <Link to={'/dicas-geral'}>Dicas</Link> &gt; 
              </span>

            </div>
            <div className="flex gap-10">
              <button className="flex items-center rounded-full dark:bg-gray-600 dark:text-white dark:hover:bg-gray-300 gap-x-2 pl-8 pr-6 mt-5 bg-white text-primary-700 hover:bg-primary-300 hover:text-white shadow-sm">
                Mais Recentes
                <Icon
                  component={KeyboardArrowDownOutlinedIcon}
                  fontSize="small"
                />
              </button>
              <button className="rounded-full h-12 px-8 mt-5 bg-primary-800 dark:hover:bg-gray-300 text-white hover:bg-primary-500 shadow-sm">
                Enviar Dica
              </button>
            </div>
          </div>
        </div>
      </section>
      <section>
        <div className="flex mx-52">
          <ul className="flex-grow w-full">
            {/* items-start */}
            {/* item-start */}
            <li className="flex items-center text-justify h-48 w-full bg-gray-100 dark:bg-gray-600 rounded-3xl my-5 ">
              <div className="flex-grow mx-10 my-5">
                <div className="flex-row">
                  <span className="bg-primary-500 text-white text-xs font-medium me-2 px-5 py-0.5 rounded-full dark:bg-blue-900 dark:text-blue-300">
                    Viagens
                  </span>
                </div>
                <div className="flex-row mt-6">
                  <span className="w-full font-semibold text-2xl">
                    Melhores pousadas para casais em Monte Verde - MG!
                  </span>
                </div>
                <div>
                  <div className="flex w-full mt-5">
                    <img
                      alt=""
                      className=" rounded-full h-10 w-12 object-cover"
                      src="https://images.unsplash.com/photo-1553514029-1318c9127859?q=80&w=1964&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                    ></img>
                    <div className=" mx-2 mt-[10px]">
                      <div className="flex justify-between">
                        <div>
                          <span className="text-gray-600 font-medium mb-[-18px]">
                            Samantha Johnson
                          </span>
                          <span className=" text-gray-400">
                            {" "}
                            . 28 de Abril, 2023
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </li>
            {/* item-end */}
            {/* item-start */}
            <li className="flex items-center text-justify h-48 w-full bg-gray-100 dark:bg-gray-600 rounded-3xl my-5 ">
              <div className="flex-grow mx-10 my-5">
                <div className="flex-row">
                  <span className="bg-primary-500 text-white text-xs font-medium me-2 px-5 py-0.5 rounded-full dark:bg-blue-900 dark:text-blue-300">
                    Viagens
                  </span>
                </div>
                <div className="flex-row mt-6">
                  <span className="w-full font-semibold text-2xl">
                    Veja o que fazer em Salvador, Bahia, um guia completo para você e sua família!
                  </span>
                </div>
                <div>
                  <div className="flex w-full mt-5">
                    <img
                      alt=""
                      className=" rounded-full h-10 w-12 object-cover"
                      src="https://images.unsplash.com/photo-1553514029-1318c9127859?q=80&w=1964&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                    ></img>
                    <div className=" mx-2 mt-[10px]">
                      <div className="flex justify-between">
                        <div>
                          <span className="text-gray-600 font-medium mb-[-18px]">
                            Samantha Johnson
                          </span>
                          <span className=" text-gray-400">
                            {" "}
                            . 28 de Abril, 2023
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </li>
            {/* item-end */}
            {/* item-start */}
            <li className="flex items-center text-justify h-48 w-full bg-gray-100 dark:bg-gray-600 rounded-3xl my-5 ">
              <div className="flex-grow mx-10 my-5">
                <div className="flex-row">
                  <span className="bg-primary-500 text-white text-xs font-medium me-2 px-5 py-0.5 rounded-full dark:bg-blue-900 dark:text-blue-300">
                    Viagens
                  </span>
                </div>
                <div className="flex-row mt-6">
                  <span className="w-full font-semibold text-2xl">
                    Grand Palladium Imbassaí - BA, conheça um dos melhores hotéis do Brasil!
                  </span>
                </div>
                <div>
                  <div className="flex w-full mt-5">
                    <img
                      alt=""
                      className=" rounded-full h-10 w-12 object-cover"
                      src="https://images.unsplash.com/photo-1553514029-1318c9127859?q=80&w=1964&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                    ></img>
                    <div className=" mx-2 mt-[10px]">
                      <div className="flex justify-between">
                        <div>
                          <span className="text-gray-600 font-medium mb-[-18px]">
                            Samantha Johnson
                          </span>
                          <span className=" text-gray-400">
                            {" "}
                            . 28 de Abril, 2023
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </li>
            {/* item-end */}
            {/* item-start */}
            <li className="flex items-center text-justify h-48 w-full bg-gray-100 dark:bg-gray-600 rounded-3xl my-5 ">
              <div className="flex-grow mx-10 my-5">
                <div className="flex-row">
                  <span className="bg-primary-500 text-white text-xs font-medium me-2 px-5 py-0.5 rounded-full dark:bg-blue-900 dark:text-blue-300">
                    Viagens
                  </span>
                </div>
                <div className="flex-row mt-6">
                  <span className="w-full font-semibold text-2xl">
                    Top 5 destinos internacionais para viajar nesse final de ano!
                  </span>
                </div>
                <div>
                  <div className="flex w-full mt-5">
                    <img
                      alt=""
                      className=" rounded-full h-10 w-12 object-cover"
                      src="https://images.unsplash.com/photo-1553514029-1318c9127859?q=80&w=1964&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                    ></img>
                    <div className=" mx-2 mt-[10px]">
                      <div className="flex justify-between">
                        <div>
                          <span className="text-gray-600 font-medium mb-[-18px]">
                            Samantha Johnson
                          </span>
                          <span className=" text-gray-400">
                            {" "}
                            . 28 de Abril, 2023
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </li>
            {/* item-end */}
            {/* item-start */}
            <li className="flex items-center text-justify h-48 w-full bg-gray-100 dark:bg-gray-600 rounded-3xl my-5 ">
              <div className="flex-grow mx-10 my-5">
                <div className="flex-row">
                  <span className="bg-primary-500 text-white text-xs font-medium me-2 px-5 py-0.5 rounded-full dark:bg-blue-900 dark:text-blue-300">
                    Viagens
                  </span>
                </div>
                <div className="flex-row mt-6">
                  <span className="w-full font-semibold text-2xl">
                    Guia turístico completo de Paris. Conheça os melhores pontos turísticos para visitar!
                  </span>
                </div>
                <div>
                  <div className="flex w-full mt-5">
                    <img
                      alt=""
                      className=" rounded-full h-10 w-12 object-cover"
                      src="https://images.unsplash.com/photo-1553514029-1318c9127859?q=80&w=1964&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                    ></img>
                    <div className=" mx-2 mt-[10px]">
                      <div className="flex justify-between">
                        <div>
                          <span className="text-gray-600 font-medium mb-[-18px]">
                            Samantha Johnson
                          </span>
                          <span className=" text-gray-400">
                            {" "}
                            . 28 de Abril, 2023
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </li>
            {/* item-end */}
            {/* item-start */}
            <li className="flex items-center text-justify h-48 w-full bg-gray-100 dark:bg-gray-600 rounded-3xl my-5 ">
              <div className="flex-grow mx-10 my-5">
                <div className="flex-row">
                  <span className="bg-primary-500 text-white text-xs font-medium me-2 px-5 py-0.5 rounded-full dark:bg-blue-900 dark:text-blue-300">
                    Viagens
                  </span>
                </div>
                <div className="flex-row mt-6">
                  <span className="w-full font-semibold text-2xl">
                    Dicas para levar suas compras com você do exterior!
                  </span>
                </div>
                <div>
                  <div className="flex w-full mt-5">
                    <img
                      alt=""
                      className=" rounded-full h-10 w-12 object-cover"
                      src="https://images.unsplash.com/photo-1553514029-1318c9127859?q=80&w=1964&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                    ></img>
                    <div className=" mx-2 mt-[10px]">
                      <div className="flex justify-between">
                        <div>
                          <span className="text-gray-600 font-medium mb-[-18px]">
                            Samantha Johnson
                          </span>
                          <span className=" text-gray-400">
                            {" "}
                            . 28 de Abril, 2023
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </li>
            {/* item-end */}
            {/* items-end */}
          </ul>

        </div>
        <div className="flex mx-52 mb-10 justify-between">
          <div className="flex items-center justify-between w-full">
            
              <button className="rounded-full w-full h-12 px-8 mt-5 bg-primary-800 dark:hover:bg-gray-300 text-white hover:bg-primary-500 shadow-sm">
                Mostrar Mais
              </button>
            
          </div>
        </div>
      </section>
    </div>
  );
};

export default Tips;
